<template>
    <Button @click="handleClick" class="ml-2" v-if="$temAcessoView('CHECKINS-EVENTOS-LP')" :loading="buttonLoading" :disabled="buttonLoading">
        <template #default>
            <div class="flex items-center">
                <span class="material-symbols-outlined mr-2" style="font-size: 17px">view_compact_alt</span>
                <span v-if="!buttonLoading">Personalizar Landing Page</span>
                <span v-else>Carregando...</span>
            </div>
        </template>
    </Button>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { tryCatch } from '@/utils/tryCatch';
import EventosService from '@/app/checkins/eventos/services.js';

const props = defineProps({
    evento: {
        type: Object,
        required: true,
    },
});

const loading = ref(false);
const buttonLoading = ref(false);

const router = useRouter();
const clickedWhileLoading = ref(false);
const landingPage = ref();

const handleClick = () => {
    if (loading.value) {
        clickedWhileLoading.value = true;
        buttonLoading.value = true;
        return;
    }

    openPage();
};

const openPage = () => {
    if (landingPage.value?.metadados?.landingPageId) {
        router.push({
            name: 'Checkins_Eventos_EditarLanding',
            params: {
                eventoId: props.evento.eventoId,
                landingPageId: landingPage.value.metadados.landingPageId,
            },
        });
        return;
    }

    router.push({
        name: 'Checkins_Eventos_NovoLanding',
        params: {
            eventoId: props.evento.eventoId,
        },
    });
};

/*
 * Os dados da landing page são carregados quando o componente é montado ao invés de
 * quando o botão é clicado, para que o usuário não tenha que esperar pela requisição
 * de dados do backend ao clicar no botão.
 */
onMounted(async () => {
    loading.value = true;
    if (props?.evento?.eventoId == null) {
        throw new Error('Evento ID não informado.');
    }

    const { data, error } = await tryCatch(EventosService.obterLandingPagePorEventoId(props.evento.eventoId));
    if (error) {
        loading.value = false;
        return;
    }

    landingPage.value = data.data;
    if (clickedWhileLoading.value) {
        buttonLoading.value = false;
        clickedWhileLoading.value = false;
        openPage();
        loading.value = false;
        return;
    }

    loading.value = false;
});
</script>
